export default {
  pinnable: false,
};
